export default __webpack_public_path__ + "static/media/clean.81f862d0.png";